import React from 'react'
import AnalyticsDetailPage from '../Detail/AnalyticsDetailPage'

const AnalyticsDetailProvider = (props:any) => {
  const { params } = props.match;
  return (
    <React.Fragment>
        <AnalyticsDetailPage metricName={params.name}/>
    </React.Fragment>
  )
}

export default AnalyticsDetailProvider